// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BlockingPeriodResponse

import { DateTimefromYmd } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BlockingPeriodApiResponse = {
	id: string;
	date: string;
	start: number;
	end: number;
	areaId: string | null;
	googleEventId: string | null;
	googleEventTitle: string | null;
	googleEventJson: { htmlLink?: string | null; hangoutLink?: string | null; organizer?: { email?: string | null } } | null;
};

export type BlockingPeriod = {
	id: string;
	date: DateTime;
	start: number;
	end: number;
	areaId: string | null;
	googleEventId: string | null;
	googleEventTitle: string | null;
	googleEventJson: { htmlLink?: string | null; hangoutLink?: string | null; organizer?: { email?: string | null } } | null;
};

export function hydrateBlockingPeriod(data: BlockingPeriodApiResponse): BlockingPeriod {
	return {
		...data,
		date: DateTimefromYmd(data.date)!,
	};
}